import AbstractScene from './AbstractScene.js';
import UI from './UI.js';

export default class Preloader extends AbstractScene {

    constructor() {
        super({
            key: "Preloader"
        })
    }
    init(data) {
        this._init(data);
    }

    preload() {
        this._preload();

        // Ajout du texte de chargement
        this.loadingText = this.make.text({
            x: this.width / 2,
            y: this.height / 2,
            text: 'Chargement... 0%',
            style: {
                font: '60px MassiliaMedium',
                fill: '#000000',
                stroke: '#FFF',
                strokeThickness: 8
            }
        });

        this.loadingText.setOrigin(0.5, 0.5);

        this.loadSprites();

        this.load.on('progress', (value) => {
            // this.chargement.setScale(value, 1);
            this.loadingText.text = 'Chargement... ' + Math.floor(value * 100) + '%';
        });

        // this.load.on('fileprogress', function (file) {
        // console.log(file.src);
        // });

        this.load.on('complete', function () {
            this.scene.add('UI', UI, true);
            this.nextScene();
        }, this);
    }

    loadSprites() {
        this.load.html('videoPlayer', 'assets/videos/video.html');

        this.load.image('intro', "assets/images/menu/image-menu.png")
        this.load.image('mqde', "assets/images/menu/mqde.png")
        this.load.image('rectIntro', "assets/images/menu/rect_menu.png")
        this.load.image('logoABC', "assets/images/menu/logo_abc.png")
        this.load.image('logoMQDE', "assets/images/menu/logo_mqde_couleur.png")
        this.load.image('logoBDF', "assets/images/menu/logo_bdf.png")
        this.load.image('logoSydo', "assets/images/menu/logo_sydo.png")
        this.load.image('backFin', 'assets/images/menu/back_fin.png')
        this.load.image('backLine', 'assets/images/menu/back_line.png')
        this.load.image('logoLinkedin', 'assets/images/menu/logo_linkedin.png')


        this.load.image('imgPlaceholder', 'assets/images/communs/img-placeholder.png')
        this.load.image('badAnswer', 'assets/images/communs/bad-answer.png')
        this.load.image('goodAnswer', 'assets/images/communs/good-answer.png')
        this.load.image('goodBox', 'assets/images/communs/good-box.png')
        this.load.image('badBox', 'assets/images/communs/bad-box.png')

        this.load.image('background1', 'assets/images/game1/background.png')
        this.load.image('dotLine', 'assets/images/game1/dot-line.png')
        this.load.image('btmLine', 'assets/images/game1/line.png')
        this.load.image('dropzone1', 'assets/images/game1/dropzone.png')
        this.load.image('adminPublicNoir', 'assets/images/game1/cards/admin-public-black.png')
        this.load.image('caisseNoir', 'assets/images/game1/cards/caisse-black.png')
        this.load.image('compteBancaireNoir', 'assets/images/game1/cards/compte-bancaire-black.png')
        this.load.image('creanceClientNoir', 'assets/images/game1/cards/creance-client-noir.png')
        this.load.image('decouvertNoir', 'assets/images/game1/cards/decouvert-noir.png')
        this.load.image('delaiFournisseurNoir', 'assets/images/game1/cards/delai-fournisseur-noir.png')
        this.load.image('empruntBancaireNoir', 'assets/images/game1/cards/emprunt-bancaire-noir.png')
        this.load.image('enCoursProdNoir', 'assets/images/game1/cards/en-cours-prod-noir.png')
        this.load.image('organismeSociauxNoir', 'assets/images/game1/cards/organisme-sociaux-noir.png')
        this.load.image('salariesNoir', 'assets/images/game1/cards/salaries-noir.png')
        this.load.image('stockVendreNoir', 'assets/images/game1/cards/stock-vendre-noir.png')
        this.load.image('adminPublic', 'assets/images/game1/cards/admin-public.png')
        this.load.image('caisse', 'assets/images/game1/cards/caisse.png')
        this.load.image('compteBancaire', 'assets/images/game1/cards/compte-bancaire.png')
        this.load.image('creanceClient', 'assets/images/game1/cards/creance-client.png')
        this.load.image('decouvert', 'assets/images/game1/cards/decouvert.png')
        this.load.image('delaiFournisseur', 'assets/images/game1/cards/delai-fournisseur.png')
        this.load.image('empruntBancaire', 'assets/images/game1/cards/emprunt-bancaire.png')
        this.load.image('enCoursProd', 'assets/images/game1/cards/en-cours-prod.png')
        this.load.image('organismeSociaux', 'assets/images/game1/cards/organisme-sociaux.png')
        this.load.image('salaries', 'assets/images/game1/cards/salaries.png')
        this.load.image('stockVendre', 'assets/images/game1/cards/stock-vendre.png')
        this.load.image('warning', 'assets/images/game1/warning.png ')
        this.load.image('cartoucheFin', 'assets/images/game1/cartouche-fin.png ')
        this.load.image('bordureFin', 'assets/images/game1/bordure-fin.png')
        this.load.image('minusLogo', 'assets/images/game1/minus-logo.png')


        this.load.image('background2', 'assets/images/game2/background.png')
        this.load.image('arrow1Good', 'assets/images/game2/arrow-1-good.png')
        this.load.image('arrow1', 'assets/images/game2/arrow-1.png')
        this.load.image('arrow2Good', 'assets/images/game2/arrow-2-good.png')
        this.load.image('arrow2', 'assets/images/game2/arrow-2.png')
        this.load.image('arrowPlaceholder', 'assets/images/game2/arrow-placeholder.png')
        this.load.image('arrowSlot', 'assets/images/game2/arrow-slot.png')
        this.load.image('label1Good', 'assets/images/game2/label-1-good.png')
        this.load.image('label1', 'assets/images/game2/label-1.png')
        this.load.image('label2Good', 'assets/images/game2/label-2-good.png')
        this.load.image('label2', 'assets/images/game2/label-2.png')
        this.load.image('labelPlaceholder', 'assets/images/game2/label-placeholder.png')
        this.load.image('labelSlot', 'assets/images/game2/label-slot.png')
        this.load.image('badAnswer2', 'assets/images/game2/bad-answer.png')


        this.load.image('background3', 'assets/images/game3/background.png')
        this.load.image('conciliation', 'assets/images/game3/cards/conciliation.png')
        this.load.image('conciliationNoir', 'assets/images/game3/cards/conciliation-noir.png')
        this.load.image('liquidation', 'assets/images/game3/cards/liquidation.png')
        this.load.image('liquidationNoir', 'assets/images/game3/cards/liquidation-noir.png')
        this.load.image('mandat', 'assets/images/game3/cards/mandat.png')
        this.load.image('mandatNoir', 'assets/images/game3/cards/mandat-noir.png')
        this.load.image('planCession', 'assets/images/game3/cards/plan-cession.png')
        this.load.image('planCessionNoir', 'assets/images/game3/cards/plan-cession-noir.png')
        this.load.image('planContinuation', 'assets/images/game3/cards/plan-continuation.png')
        this.load.image('planContinuationNoir', 'assets/images/game3/cards/plan-continuation-noir.png')
        this.load.image('planSauvegarde', 'assets/images/game3/cards/plan-sauvegarde.png')
        this.load.image('planSauvegardeNoir', 'assets/images/game3/cards/plan-sauvegarde-noir.png')
        
        
        
        
        
        
        
        
        
        
        
        
























    }
}